import * as CSS from 'csstype';
import React from 'react';

const icons = {
  //
  // Other icons - put new SVGs here or create a new category
  //
  // pro tip: https://svg2jsx.com/
  squarespace: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" stroke="none" fill="currentColor">
      <path d="M193.219 334.467c-8.669 8.67-8.669 22.721 0 31.389 8.671 8.67 22.722 8.67 31.392 0l141.213-141.212c17.332-17.331 45.435-17.331 62.764 0 17.331 17.331 17.331 45.433 0 62.765l-138.491 138.48c17.312 17.332 45.398 17.35 62.728.039l.036-.039 107.137-107.127c34.67-34.67 34.67-90.867 0-125.527-34.671-34.671-90.875-34.671-125.528 0L193.219 334.467zm219.691-94.155c-8.67-8.669-22.721-8.669-31.383 0L240.296 381.525c-17.312 17.332-45.396 17.35-62.727.043l-.046-.043c-8.66-8.662-22.702-8.67-31.372-.008l-.009.008c-8.671 8.662-8.679 22.711-.019 31.381l.019.018c34.661 34.654 90.866 34.654 125.525 0L412.9 271.693c8.67-8.668 8.67-22.72.01-31.381zm-235.377 78.459l141.213-141.215c8.662-8.669 8.662-22.721 0-31.39-8.66-8.662-22.704-8.662-31.363 0L146.143 287.38c-17.322 17.33-45.425 17.34-62.756.008l-.009-.008c-17.33-17.322-17.349-45.407-.027-62.746l.027-.027 138.51-138.509c-17.32-17.331-45.415-17.34-62.755-.019l-.018.019L51.997 193.234c-34.661 34.669-34.661 90.865 0 125.527 34.679 34.673 90.857 34.673 125.536.01zm-78.459-47.078c8.66 8.662 22.702 8.662 31.364 0l141.239-141.222c17.321-17.331 45.416-17.34 62.746-.02l.018.02c8.671 8.669 22.721 8.669 31.382 0 8.67-8.67 8.67-22.721 0-31.383-34.669-34.67-90.857-34.67-125.527 0L99.074 240.312c-8.671 8.662-8.671 22.714-.011 31.382h.011z"></path>
    </svg>
  ),
  wix: () => (
    <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
      <path d="M308.742 166.654c0 9.365 1.494 23.496-20.614 31.502-6.843 2.48-11.463 6.944-11.463 6.944 0-22.282 3.391-30.347 12.505-35.119 7.009-3.671 19.572-3.327 19.572-3.327zm-83.231 25.543l-24.61 95.35-20.469-78.034c-5.528-22.992-14.956-34.88-34.81-34.88-19.672 0-29.224 11.629-34.809 34.88l-20.47 78.034-24.61-95.35c-3.989-19.204-22.583-27.505-39.732-25.349L73.13 345.047s15.546 1.121 23.33-2.847c10.221-5.21 15.079-9.229 21.268-33.472 5.513-21.613 20.922-85.107 22.368-89.627 3.421-10.738 7.97-9.927 11.067 0 1.416 4.527 16.854 68.014 22.368 89.627 6.181 24.243 11.047 28.262 21.268 33.472 7.777 3.968 23.33 2.847 23.33 2.847l47.129-178.198c-17.552-2.207-35.809 6.418-39.747 25.348zm83.217 3.746s-2.946 4.556-9.674 8.316c-4.32 2.414-8.468 4.052-12.917 6.188-10.882 5.219-9.472 10.026-9.472 25.3v109.3s11.895 1.503 19.671-2.466c10.012-5.104 12.313-10.025 12.406-32.186V202.391l-.015.007v-6.455h.001zm117.47 60.432l59.801-88.938s-25.235-4.298-37.733 7.08c-9.559 8.696-17.546 21.238-38.941 52.088-.338.523-4.492 7.575-9.395 0-21.053-30.354-29.326-43.334-38.941-52.088-12.5-11.378-37.735-7.08-37.735-7.08l59.8 88.938-59.634 88.663s26.283 3.322 38.775-8.056c8.259-7.519 12.636-14.641 37.741-50.829 4.896-7.561 9.035-.554 9.395 0 21.132 30.459 28.197 41.73 38.194 50.829 12.499 11.378 38.324 8.056 38.324 8.056l-59.651-88.663z"></path>
    </svg>
  ),

  //
  // Heroicons -- https://heroicons.com/ -- These are all using the medium-sized variant; designed for 24x24.
  //

  dotsVertical: () => (
    <svg fill="currentColor" viewBox="0 0 20 20">
      <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
    </svg>
  ),
  globeAlt: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
      />
    </svg>
  ),
  scale: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"
      />
    </svg>
  ),
  lightningBolt: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  annotation: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
      />
    </svg>
  ),
  mail: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  ),
  ticket: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
      />
    </svg>
  ),
  videoCamera: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
      />
    </svg>
  ),
  eye: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      />
    </svg>
  ),
  lightBulb: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
      />
    </svg>
  ),
  musicNote: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"
      />
    </svg>
  ),
  bookOpen: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
      />
    </svg>
  ),
  pencilAlt: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
      />
    </svg>
  ),
  minus: () => (
    // Note: small icon size
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
    </svg>
  ),
  chevronDown: () => (
    // Note: small icon size
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  ),
  check: () => (
    // Note: small icon size
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  ),
  userGroup: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  ),
  arrowsExpand: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
      />
    </svg>
  ),
  cog: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  microphone: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
      />
    </svg>
  ),
  desktopComputer: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  ),
  chevronLeft: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
    </svg>
  ),
  chevronRight: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
    </svg>
  ),
  logout: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>
  ),
  x: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  minusCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  emojiHappy: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  plus: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
    </svg>
  ),
  home: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
    </svg>
  ),
  users: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  ),
  chartBar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      />
    </svg>
  ),
  calendar: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  ),
  collection: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
      />
    </svg>
  ),
  cloud: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
      />
    </svg>
  ),
  stop: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
      />
    </svg>
  ),
  user: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
  ),
  externalLink: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
  ),
  chat: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
      />
    </svg>
  ),
  code: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
    </svg>
  ),
  exclamation: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  ),
  lockClosed: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      />
    </svg>
  ),
  lockOpen: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"
      />
    </svg>
  ),
  userCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  download: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
      />
    </svg>
  ),
  clock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  informationCircle: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  //
  // Custom icons
  //

  share: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path d="M2.68,19.66V11.94H1.39a.73.73,0,0,0-.73.72v8.91a.73.73,0,0,0,.73.73H14.58a.73.73,0,0,0,.73-.73V20.38H3.41A.73.73,0,0,1,2.68,19.66Z" />
      <path d="M7.3,15.14V7.42H6a.72.72,0,0,0-.72.72v8.92a.72.72,0,0,0,.72.72H19.2a.72.72,0,0,0,.72-.72V15.87H8A.73.73,0,0,1,7.3,15.14Z" />
      <path d="M23.81,2.9H10.62a.73.73,0,0,0-.73.73v8.91a.69.69,0,0,0,.17.44.7.7,0,0,0,.56.28H23.81a.73.73,0,0,0,.73-.72V3.63A.73.73,0,0,0,23.81,2.9Z" />
    </svg>
  ),
  minimize: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path className="cls-1" d="M23.87,12H1.33a1.25,1.25,0,0,0,0,2.5H23.87a1.25,1.25,0,0,0,0-2.5Z" />
    </svg>
  ),
  camera: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <rect x="0.79" y="5.72" width="15.7" height="13.76" rx="1.77" />
      <path d="M24.41,18.36c0,.59-.35.74-.78.33l-3.2-3.08a2.89,2.89,0,0,1-.78-1.82V11.43a2.89,2.89,0,0,1,.78-1.82l3.2-3.08c.43-.41.78-.26.78.33Z" />
    </svg>
  ),
  cameraOff: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path
        className="cls-1"
        d="M25.1,18.36c0,.59-.35.74-.78.33l-3.2-3.08a2.89,2.89,0,0,1-.78-1.82V11.43a2.89,2.89,0,0,1,.78-1.82l3.2-3.08c.43-.41.78-.26.78.33Z"
      />
      <path
        className="cls-1"
        d="M19.65,3a1.1,1.1,0,0,0-.75-.31,1.07,1.07,0,0,0-.74.31L15.42,5.72,2.1,19,.41,20.73a1.06,1.06,0,0,0,.74,1.8,1.05,1.05,0,0,0,.74-.31l2.74-2.74L17.1,7l2.55-2.54A1.06,1.06,0,0,0,19.65,3Z"
      />
      <path className="cls-1" d="M3.25,5.72A1.78,1.78,0,0,0,1.48,7.49V17.58L13.34,5.72Z" />
      <path className="cls-1" d="M15.4,19.48a1.78,1.78,0,0,0,1.78-1.77V9L6.71,19.48Z" />
    </svg>
  ),
  expand: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path
        className="cls-1"
        d="M5.54,4.13h2.8a1,1,0,0,0,0-2H2.13V8.34a1,1,0,0,0,2,0V5.55l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
      />
      <path
        className="cls-1"
        d="M16.86,2.13a1,1,0,0,0,0,2h2.8l-5,5a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5V8.34a1,1,0,0,0,2,0V2.13Z"
      />
      <path
        className="cls-1"
        d="M22.07,15.86a1,1,0,0,0-1,1v2.79l-5-5a1,1,0,1,0-1.42,1.42l5,5h-2.8a1,1,0,0,0,0,2h6.21V16.86A1,1,0,0,0,22.07,15.86Z"
      />
      <path
        className="cls-1"
        d="M9.09,14.68l-5,5V16.86a1,1,0,0,0-2,0v6.21H8.34a1,1,0,0,0,0-2H5.54l5-5a1,1,0,1,0-1.42-1.42Z"
      />
    </svg>
  ),
  leave: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path
        className="cls-1"
        d="M4.69,13.65h9.92a1.05,1.05,0,0,0,0-2.1H4.69L7.82,8.42A1,1,0,1,0,6.34,6.94L.67,12.6l5.69,5.69a1.05,1.05,0,0,0,1.49,0,1.06,1.06,0,0,0,0-1.49Z"
      />
      <path
        className="cls-1"
        d="M22.3,3H13.21A2.23,2.23,0,0,0,11,5.19V7.65a1.05,1.05,0,0,0,2.1,0V5.19a.12.12,0,0,1,.13-.12H22.3a.12.12,0,0,1,.13.12V20a.12.12,0,0,1-.13.12H13.21a.12.12,0,0,1-.13-.12V17.52a1,1,0,1,0-2.1,0V20a2.23,2.23,0,0,0,2.23,2.23H22.3A2.23,2.23,0,0,0,24.53,20V5.19A2.23,2.23,0,0,0,22.3,3Z"
      />
    </svg>
  ),
  mic: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path
        className="cls-1"
        d="M20.56,12.37a1.05,1.05,0,1,0-2.1,0,5.86,5.86,0,0,1-11.72,0,1,1,0,0,0-2.1,0,8,8,0,0,0,6.91,7.89v2.6h-3a1,1,0,0,0,0,2.1h8.06a1.05,1.05,0,0,0,0-2.1h-3v-2.6A8,8,0,0,0,20.56,12.37Z"
      />
      <rect x="8.13" y="0.24" width="8.84" height="14.93" rx="4.42" />
    </svg>
  ),
  micWithLevel: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <defs>
        <linearGradient id="micLevel" x1="50%" x2="50%" y1="100%" y2="0%" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00ff00" offset="0%" />
          <stop className="mic-level-boundary" stopColor="#00ff00" offset="100%" />
          <stop className="mic-level-boundary" stopColor="currentcolor" offset="100%" />
          <stop stopColor="currentcolor" offset="100%" />
        </linearGradient>
      </defs>
      <path
        fill="url(#micLevel)"
        className="cls-1"
        d="M20.56,12.37a1.05,1.05,0,1,0-2.1,0,5.86,5.86,0,0,1-11.72,0,1,1,0,0,0-2.1,0,8,8,0,0,0,6.91,7.89v2.6h-3a1,1,0,0,0,0,2.1h8.06a1.05,1.05,0,0,0,0-2.1h-3v-2.6A8,8,0,0,0,20.56,12.37Z"
      />
      <rect x="8.13" y="0.24" width="8.84" height="14.93" rx="4.42" fill="url(#micLevel)" />
    </svg>
  ),
  micOff: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <path
        className="cls-1"
        d="M6.45,12a1,1,0,0,0-2.1,0,8.47,8.47,0,0,0,.86,3.72l1.61-1.61A6.41,6.41,0,0,1,6.45,12Z"
      />
      <path
        className="cls-1"
        d="M11.86,20.44V23h-3a1,1,0,0,0,0,2.1h8.05a1.05,1.05,0,0,0,0-2.1H14V20.44A8.57,8.57,0,0,0,21.47,12a1.05,1.05,0,1,0-2.1,0,6.47,6.47,0,0,1-6.46,6.46,6.36,6.36,0,0,1-2.71-.61L8.65,19.36A8.84,8.84,0,0,0,11.86,20.44Z"
      />
      <path className="cls-1" d="M17.26,10.74,13,15A4.4,4.4,0,0,0,17.26,10.74Z" />
      <path
        className="cls-1"
        d="M12.86.07A4.41,4.41,0,0,0,8.44,4.48v6.1a4.51,4.51,0,0,0,.3,1.56L17.2,3.68A4.4,4.4,0,0,0,12.86.07Z"
      />
      <path
        className="cls-1"
        d="M21.48,1.92a1.05,1.05,0,0,0-.75.31L3,20a1,1,0,0,0,0,1.48,1,1,0,0,0,.74.31,1.05,1.05,0,0,0,.75-.31L22.22,3.71a1,1,0,0,0,0-1.48A1,1,0,0,0,21.48,1.92Z"
      />
    </svg>
  ),
  micOffWithLevel: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <defs>
        <linearGradient id="micLevel" x1="50%" x2="50%" y1="100%" y2="0%" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00ff00" offset="0%" />
          <stop className="mic-level-boundary" stopColor="#00ff00" offset="100%" />
          <stop className="mic-level-boundary" stopColor="currentcolor" offset="100%" />
          <stop stopColor="currentcolor" offset="100%" />
        </linearGradient>
      </defs>
      <path
        fill="url(#micLevel)"
        className="cls-1"
        d="M6.45,12a1,1,0,0,0-2.1,0,8.47,8.47,0,0,0,.86,3.72l1.61-1.61A6.41,6.41,0,0,1,6.45,12Z"
      />
      <path
        fill="url(#micLevel)"
        className="cls-1"
        d="M11.86,20.44V23h-3a1,1,0,0,0,0,2.1h8.05a1.05,1.05,0,0,0,0-2.1H14V20.44A8.57,8.57,0,0,0,21.47,12a1.05,1.05,0,1,0-2.1,0,6.47,6.47,0,0,1-6.46,6.46,6.36,6.36,0,0,1-2.71-.61L8.65,19.36A8.84,8.84,0,0,0,11.86,20.44Z"
      />
      <path fill="url(#micLevel)" className="cls-1" d="M17.26,10.74,13,15A4.4,4.4,0,0,0,17.26,10.74Z" />
      <path
        fill="url(#micLevel)"
        className="cls-1"
        d="M12.86.07A4.41,4.41,0,0,0,8.44,4.48v6.1a4.51,4.51,0,0,0,.3,1.56L17.2,3.68A4.4,4.4,0,0,0,12.86.07Z"
      />
      <path
        fill="url(#micLevel)"
        className="cls-1"
        d="M21.48,1.92a1.05,1.05,0,0,0-.75.31L3,20a1,1,0,0,0,0,1.48,1,1,0,0,0,.74.31,1.05,1.05,0,0,0,.75-.31L22.22,3.71a1,1,0,0,0,0-1.48A1,1,0,0,0,21.48,1.92Z"
      />
    </svg>
  ),
  settings: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" stroke="none" viewBox="0 0 25.2 25.2">
      <g id="_6v5T5Y" data-name="6v5T5Y">
        <path d="M2.69,13.37V11.83a1,1,0,0,1,.94-.71c.53-.07,1-.18,1.58-.26a.24.24,0,0,0,.24-.21,6.36,6.36,0,0,1,.73-1.74.21.21,0,0,0,0-.28c-.34-.47-.69-1-1-1.42A.87.87,0,0,1,5.25,6L6,5.29a.89.89,0,0,1,1.3-.1l1.5,1.07a7.89,7.89,0,0,1,2-.85.27.27,0,0,0,.12-.17c.11-.61.2-1.23.31-1.84A.84.84,0,0,1,12,2.7c.38,0,.75,0,1.12,0a.87.87,0,0,1,.93.79c.09.59.2,1.17.29,1.76a.2.2,0,0,0,.17.19,7,7,0,0,1,2.19,1,.2.2,0,0,0,.27,0c.5-.31,1-.63,1.49-.93a.87.87,0,0,1,1.2.16l.7.78a.88.88,0,0,1,0,1.25c-.37.46-.73.92-1.1,1.37a.21.21,0,0,0,0,.26c.18.44.35.88.5,1.33a.29.29,0,0,0,.26.22c.6.1,1.2.19,1.79.31a.84.84,0,0,1,.7.85v1.09a.87.87,0,0,1-.81,1L20,14.34a.21.21,0,0,0-.2.19A7.06,7.06,0,0,1,19,16.3a.21.21,0,0,0,0,.28l1.05,1.48a.85.85,0,0,1-.1,1.2l-.72.73a.89.89,0,0,1-1.27.1L16.56,19a.18.18,0,0,0-.24,0,7.11,7.11,0,0,1-1.8.74.18.18,0,0,0-.16.17c-.08.52-.18,1-.25,1.56a1.06,1.06,0,0,1-.74,1H11.83a1,1,0,0,1-.69-.85c-.08-.56-.19-1.12-.27-1.68a.23.23,0,0,0-.19-.22,6.84,6.84,0,0,1-2.12-.94.21.21,0,0,0-.26,0l-1.5.95a.88.88,0,0,1-1.23-.17l-.66-.74a.89.89,0,0,1,0-1.31L6,16.15c-.21-.58-.39-1.13-.6-1.67a.27.27,0,0,0-.2-.13c-.5-.09-1-.18-1.5-.25A1.08,1.08,0,0,1,2.69,13.37Zm5.39-.77A4.56,4.56,0,1,0,12.64,8,4.57,4.57,0,0,0,8.08,12.6Z" />
      </g>
    </svg>
  ),
  startRecording: () => (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 19.5C14.7467 19.5 19 15.2467 19 10C19 4.75329 14.7467 0.5 9.5 0.5C4.25329 0.5 0 4.75329 0 10C0 15.2467 4.25329 19.5 9.5 19.5ZM9.49999 18.075C13.9597 18.075 17.575 14.4597 17.575 10C17.575 5.54034 13.9597 1.92504 9.49999 1.92504C5.04029 1.92504 1.42499 5.54034 1.42499 10C1.42499 14.4597 5.04029 18.075 9.49999 18.075Z"
        fill="currentColor"
      />
      <path
        d="M3.65328 9.94693C3.66724 8.40543 4.28939 6.93181 5.38436 5.8467C6.52934 4.71204 8.08788 4.12919 9.71905 4.15691C11.2569 4.21454 12.7102 4.87617 13.7635 5.99845C14.8185 7.12249 15.3869 8.61767 15.345 10.1587C15.3031 11.6997 14.6544 13.1618 13.54 14.2269C12.4255 15.292 10.9355 15.8739 9.39422 15.846C7.85291 15.8181 6.38498 15.1826 5.30983 14.0778C4.23469 12.9731 3.63932 11.4884 3.65328 9.94693Z"
        stroke="currentColor"
        strokeWidth="1.60588"
      />
    </svg>
  ),
  stopRecording: () => (
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
      />
    </svg>
  ),
  chatBubble: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5238 12.0794C23.5238 7.69844 19.6607 4.0032 14.5143 3.19051C13.77 3.06817 13.0168 3.00447 12.2619 3.00003C6.02857 2.98733 1 7.06352 1 12.0794C1.0557 13.7238 1.58097 15.321 2.51735 16.6931C3.45372 18.0652 4.76444 19.1583 6.30357 19.8508C8.1464 20.7691 10.19 21.2438 12.2619 21.2349C13.4802 21.2331 14.6923 21.0664 15.8631 20.7397C17.6057 21.8833 19.5709 22.6698 21.6381 23.0508C20.8633 21.6931 20.3069 20.2286 19.9881 18.708C21.056 17.9343 21.9291 16.9359 22.5415 15.7877C23.154 14.6395 23.4898 13.3716 23.5238 12.0794ZM7.25952 13.3492C7.06354 13.4083 6.856 13.4218 6.65363 13.3887C6.45127 13.3557 6.25974 13.277 6.09451 13.159C5.92928 13.041 5.79496 12.8869 5.70239 12.7093C5.60982 12.5317 5.56159 12.3355 5.56159 12.1365C5.56159 11.9375 5.60982 11.7413 5.70239 11.5637C5.79496 11.3861 5.92928 11.2321 6.09451 11.1141C6.25974 10.9961 6.45127 10.9174 6.65363 10.8843C6.856 10.8513 7.06354 10.8648 7.25952 10.9238C7.52641 11.0042 7.75977 11.1653 7.9255 11.3835C8.09123 11.6017 8.18064 11.8655 8.18064 12.1365C8.18064 12.4075 8.09123 12.6714 7.9255 12.8896C7.75977 13.1078 7.52641 13.2689 7.25952 13.3492ZM12.2619 13.3492C12.0029 13.3492 11.7497 13.2748 11.5344 13.1352C11.319 12.9957 11.1512 12.7974 11.0521 12.5653C10.9529 12.3333 10.927 12.078 10.9775 11.8317C11.0281 11.5853 11.1528 11.3591 11.3359 11.1815C11.5191 11.0039 11.7524 10.8829 12.0064 10.834C12.2605 10.785 12.5238 10.8101 12.763 10.9062C13.0023 11.0023 13.2068 11.1651 13.3507 11.3739C13.4946 11.5827 13.5714 11.8282 13.5714 12.0794C13.5579 12.4073 13.414 12.7174 13.1698 12.9446C12.9257 13.1719 12.6003 13.2987 12.2619 13.2984V13.3492ZM17.2643 13.3492C17.0053 13.3492 16.7521 13.2748 16.5368 13.1352C16.3214 12.9957 16.1536 12.7974 16.0544 12.5653C15.9553 12.3333 15.9294 12.078 15.9799 11.8317C16.0305 11.5853 16.1552 11.3591 16.3383 11.1815C16.5215 11.0039 16.7548 10.8829 17.0088 10.834C17.2628 10.785 17.5261 10.8101 17.7654 10.9062C18.0047 11.0023 18.2092 11.1651 18.3531 11.3739C18.497 11.5827 18.5738 11.8282 18.5738 12.0794C18.5603 12.4073 18.4164 12.7174 18.1722 12.9446C17.9281 13.1719 17.6027 13.2987 17.2643 13.2984V13.3492Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export type IconSvgName = keyof typeof icons;

interface Props {
  name: IconSvgName;
  className?: string;
  style?: CSS.Properties;
  ref?: (el: HTMLDivElement) => void;
}

const IconSvg = ({ name, className, style }: Props, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div className={className} ref={ref} style={style as any}>
      {icons[name]()}
    </div>
  );
};

export default React.forwardRef(IconSvg);
